import { createComponent } from '../lib';
import { VmCaptions } from '@vime/core';
import { define } from '../lib';
define('vm-captions', VmCaptions);
;
export default createComponent('vm-captions', new Set(['hidden', 'isControlsActive', 'isVideoView', 'playbackStarted', 'textTracks', 'currentTextTrack', 'isTextTrackVisible']));
